<cms-resource-explorer class="h-100"
  [applicationCode]="applicationCode()"
  [usePathsOnly]="true"
  [mini]="mini()"
  [allowEdit]="allowEdit()"
  [baseQuery]="baseQuery()"
  explorerTitle="Jupiter Help"
  [menu]="configMainMenu" />
